import { ProfileService } from "./profile";

export const watchInactivityTime = function (profile: ProfileService) {
    const inactivityTimeout = 900_000;//15min in ms
    let time: NodeJS.Timeout;
    window.onload = resetTimer;
    document.onmousedown = resetTimer;
    document.onkeydown = resetTimer;

    function logoutIfLogged() {
        if (!profile.isLogged)
            return;
        profile.logOut();
    }

    function resetTimer() {
        clearTimeout(time);
        time = setTimeout(logoutIfLogged, inactivityTimeout);
    }
}